import { MenuItemActionType } from './actions';
import { getFirstFocusIndex, getInitialTabIndex, getLastFocusIndex, getNextFocusIndex, resetMenuItems, updateMenuItems } from './reducerUtils';
export const initialMenuItemState = {
  menuItems: {},
  focusOrder: [],
  currentlyFocused: 0,
  shouldManageTabIndex: false
};
function reducer(state, action) {
  switch (action.type) {
    case MenuItemActionType.ADD_MENU_ITEM:
      {
        if (state.menuItems[action.id]) {
          return Object.assign({}, state, {
            menuItems: Object.assign({}, state.menuItems, {
              [action.id]: Object.assign({}, state.menuItems[action.id], {
                visuallyHidden: !state.menuItems[action.id].visuallyHidden
              })
            })
          });
        }
        return Object.assign({}, state, {
          menuItems: Object.assign({}, state.menuItems, {
            [action.id]: {
              id: action.id,
              tabIndex: getInitialTabIndex(state.focusOrder, state.shouldManageTabIndex),
              isFocused: false,
              visuallyHidden: !!action.visuallyHidden
            }
          }),
          focusOrder: [...state.focusOrder, action.id]
        });
      }
    case MenuItemActionType.FOCUS_FIRST_MENU_ITEM:
      {
        const firstFocusIndex = getFirstFocusIndex(state);
        return Object.assign({}, state, {
          menuItems: updateMenuItems(state.menuItems, state.focusOrder[firstFocusIndex], state.shouldManageTabIndex),
          currentlyFocused: firstFocusIndex
        });
      }
    case MenuItemActionType.FOCUS_LAST_MENU_ITEM:
      {
        const lastItemIndex = getLastFocusIndex(state);
        return Object.assign({}, state, {
          menuItems: updateMenuItems(state.menuItems, state.focusOrder[lastItemIndex], state.shouldManageTabIndex),
          currentlyFocused: lastItemIndex
        });
      }
    case MenuItemActionType.FOCUS_NEXT_MENU_ITEM:
      {
        const nextItemIndex = getNextFocusIndex(state, 1, action.shouldLoopFocus);
        return Object.assign({}, state, {
          menuItems: updateMenuItems(state.menuItems, state.focusOrder[nextItemIndex], state.shouldManageTabIndex),
          currentlyFocused: nextItemIndex
        });
      }
    case MenuItemActionType.FOCUS_PREVIOUS_MENU_ITEM:
      {
        const previousItemIndex = getNextFocusIndex(state, -1, action.shouldLoopFocus);
        return Object.assign({}, state, {
          menuItems: updateMenuItems(state.menuItems, state.focusOrder[previousItemIndex], state.shouldManageTabIndex),
          currentlyFocused: previousItemIndex
        });
      }
    case MenuItemActionType.FOCUS_RESET:
      {
        return Object.assign({}, state, {
          menuItems: resetMenuItems(state),
          currentlyFocused: 0
        });
      }
    case MenuItemActionType.HIDE_MENU_ITEM:
      {
        return Object.assign({}, state, {
          menuItems: Object.assign({}, state.menuItems, {
            [action.id]: Object.assign({}, state.menuItems[action.id], {
              visuallyHidden: true
            })
          })
        });
      }
    default:
      {
        console.error(`Unknown action: ${action}`);
        return state;
      }
  }
}
export default reducer;